<template>
  <!-- 患者情報編集 -->
  <div id="AppPatientManagementEditPatient">
    <!-- 上部余白 -->
    <div style="height: 10px" />
    <div style="margin-left: 50px; margin-right: 50px">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">患者情報編集</label>
        </div>
      </div>

      <!-- 詳細表示 -->
      <div style="detailArea">
        <div>
          <table class="table is-full">
            <table style="width: 100%">
              <tr>
                <th style="border-bottom: solid 1px; width: 180px">
                  患者コード
                </th>
                <td style="border-bottom: solid 1px" colspan="6">
                  <span>{{ data.patientCode }}</span>
                  <div style="float: right">
                    <template>
                      <b-checkbox
                        v-model="data.interestPatient"
                        name="interestPatient"
                      >
                        <b-icon
                          icon="account-alert"
                          :type="data.interestPatient ? 'is-danger' : ''"
                        ></b-icon>
                      </b-checkbox>
                    </template>
                    <template v-if="data.followUpCall">
                      <b-icon icon="volume-high" type="is-info"> </b-icon>
                      <span class="has-text-info">フォローアップコール</span>
                    </template>
                  </div>
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">患者名（患者名カナ）</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  <span>
                    {{ data.patientName }}
                    <template v-if="data.patientNameKana">
                      （{{ data.patientNameKana }}）
                    </template>
                  </span>
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">住所</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  <span>〒{{ data.postCode }} {{ data.address }}</span>
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">電話</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  <span>{{ data.phoneNumber }}</span>
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">携帯電話</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  {{ data.mobilePhoneNumber }}
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">緊急連絡先</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  {{ data.emergencyContact }}
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">勤務先名</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  {{ data.employment }}
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">勤務連絡先</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  {{ data.employmentContact }}
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">誕生日</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  {{ data.birthday }}
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">年齢</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  {{ calcAge }}
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">性別</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  {{ data.gender | genderFilter }}
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">疾患名</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  {{ joinProductDetailValue("diseaseName") }}
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">感染症</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  {{
                    joinProductDetailCode2Name(
                      "infection",
                      "INFECTION_TYPE_MAP"
                    )
                  }}
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">直送先種別</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  {{
                    joinProductDetailCode2Name(
                      "directDestinationType",
                      "DIRECT_DESTINATION_TYPE_MAP"
                    )
                  }}
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">リースアップ種別</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  {{
                    joinProductDetailCode2Name(
                      "leaseUpType",
                      "LEASEUP_TYPE_MAP"
                    )
                  }}
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">
                  ドリームマッパー（アプリ）
                </th>
                <td style="border-bottom: solid 1px" colspan="6">
                  <b-checkbox v-model="data.dreamMapper" name="dreamMapper">
                    使用する
                  </b-checkbox>
                </td>
              </tr>

              <tr>
                <th style="border-bottom: solid 1px">メモ</th>
                <td style="border-bottom: solid 1px" colspan="6">
                  <b-input
                    type="textarea"
                    v-model="data.memo"
                    name="memo"
                    data-vv-as="メモ"
                  ></b-input>
                </td>
              </tr>

              <tr>
                <td style="border-bottom: solid 1px" colspan="6">
                  <file-chooser
                    v-model="data.files"
                    @download-file="downloadFile($event)"
                  ></file-chooser>
                </td>
              </tr>
            </table>
          </table>
        </div>
      </div>
    </div>

    <!-- 下部余白 -->
    <div style="height: 50px" />

    <!-- フッタ -->
    <div class="columns">
      <div class="column is-full" style="text-align: center">
        <b-button
          v-on:click="back"
          class="button"
          type="is-primary"
          icon-left="keyboard-backspace"
          native-type="button"
          >戻る</b-button
        >
        <b-button
          v-on:click="save"
          class="button"
          type="is-primary"
          icon-left="content-save"
          native-type="button"
          >登録</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import FileChooser from "./common/FileChooser.vue";
import * as patientUtil from "../utils/patient";

export default {
  name: "AppPatientManagementEditPatientSleep",

  computed: {
    calcAge: function () {
      let age = 0;
      if (this.data.birthday) {
        let nowInt = Number(this.formatDate2(new Date()).replace(/\//g, ""));
        let birthdayInt = Number(this.data.birthday.replace(/\//g, ""));
        age = Math.floor((nowInt - birthdayInt) / 10000);
      }

      return age;
    },
  },

  methods: {
    joinProductDetailValue: function (valueName) {
      const productDetails = this.data.productDetails;

      // 重複除外
      const values = [];
      for (const productDetail of productDetails) {
        const value = productDetail[valueName];
        const exists = values.includes(value);
        if (!exists) {
          values.push(value);
        }
      }

      const res = values.join("<br/>");

      return res;
    },

    joinProductDetailCode2Name: function (codeName, mapName) {
      const productDetails = this.data.productDetails;

      // 重複除外
      const codes = [];
      for (const productDetail of productDetails) {
        const code = productDetail[codeName];
        const exists = codes.includes(code);
        if (!exists) {
          codes.push(code);
        }
      }

      // 名称取得
      const names = [];
      let map = Object.values(patientUtil[mapName]);
      for (const code of codes) {
        const info = map.find((elem) => elem.code == code);
        if (info) {
          names.push(info.name);
        }
      }

      const res = names.join("<br/>");

      return res;
    },

    downloadFile: function (file) {
      this.targetFile = file;
      this.downloadS3ApiCall(
        this.getPatientFile,
        this.showErrorMessage,
        this.$store.state.subSystem
      );
      return;
    },

    getPatientFile: function (client) {
      const res = client.apis.apiPatient.getPatientFileGET({
        id: this.targetFile.id,
      });
      this.targetFile = null;
      return res;
    },

    save: function () {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if (this.data.files.length) {
            // ファイルオブジェクト除去
            let files = JSON.parse(JSON.stringify(this.data.files));
            for (const file of files) {
              delete file.file;
            }
            this.uploadFiles = files;

            // 添付ファイルアップロード
            try {
              this.s3UploadData = await this.multipleUpload(
                this.data.files,
                this.$store.state.subSystem,
                this.showErrorMessage,
              );
            } catch (error) {
              // エラーコールバックで処理済み
              return;
            }
          }

          const excuteApi = this.setPatientInfo;
          const successCallBack = this.setPatientInfoSuccess;
          const errorCallBack = this.showErrorMessage;
          this.apiCall(
            excuteApi,
            successCallBack,
            errorCallBack,
            this.$store.state.subSystem
          );
        } else {
          scrollTo(0, 0);
        }
      });
    },

    setPatientInfo: function (client) {
      // パラメータ編集
      const data = JSON.parse(JSON.stringify(this.data));

      let setData = {
        patientCode: data.patientCode,
        patientNameKana: data.patientNameKana,
        interestPatient: data.interestPatient,
        dreamMapper: data.dreamMapper,
        memo: data.memo,
        files: this.uploadFiles,
      };

      if (this.s3UploadData && this.s3UploadData.identifier) {
        setData.s3UploadData = this.s3UploadData;
      }

      // 患者情報更新: Web API
      return client.apis.apiPatient.putPatientPUT({
        body: setData,
      });
    },

    setPatientInfoSuccess: function (result) {
      this.loadData();
      this.showSuccess(result);
    },

    back: function () {
      this.$router.push({
        name: "AppPatientManagementSleep",
        params: {
          patientSearchFlag: true,
          searchConditions: this.searchConditions,
        },
      });
    },

    loadData: function () {
      // 患者情報取得
      this.apiCall(
        this.getPatient,
        this.getPatientSuccess,
        this.showErrorMessage,
        this.$store.state.subSystem
      );
      return;
    },

    getPatient: function (client) {
      // 患者情報取得
      const res = client.apis.apiPatient.getPatientGET({
        patientCode: this.$route.params["code"],
      });

      return res;
    },

    getPatientSuccess: function (result) {
      // 患者情報取得結果設定
      this.data = result.obj;
      return;
    },
  },

  data() {
    const searchConditions = this.$route.params.searchConditions;

    return {
      data: {
        productDetails: [],
        files: [],
      },
      searchConditions,
      targetFile: null,
      uploadFiles: [],
      s3UploadData: null,
    };
  },

  filters: {},

  components: {
    "file-chooser": FileChooser,
  },

  created: function () {
    this.loadData();
    return;
  },

  mounted: function () {},

  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/AppPatientManagementEditPatientSleep.vue